import { create } from 'zustand';
import type { ProfileGroup } from 'types/Page';

interface PostsSelection {
  selectedProfiles: number[];
  selectedGroups: number[];
  profileGroups: ProfileGroup[];
}

/**
 * Mirrors the posts filter selection so consumers rendered *above* the posts provider can
 * read it. `filterState` is local to the posts Container, and the url only mirrors it once
 * a filter changes, so neither is reachable from the app layout.
 */
export const usePostsSelectionState = create<
  PostsSelection & {
    setSelection: (selection: PostsSelection) => void;
    clearSelection: () => void;
  }
>()((set) => ({
  selectedProfiles: [],
  selectedGroups: [],
  profileGroups: [],
  setSelection: (selection) => set(selection),
  clearSelection: () =>
    set({ selectedProfiles: [], selectedGroups: [], profileGroups: [] }),
}));
